import { render, staticRenderFns } from "./AccountConfirm.vue?vue&type=template&id=2786d1e0&scoped=true"
import script from "./AccountConfirm.vue?vue&type=script&lang=js"
export * from "./AccountConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786d1e0",
  null
  
)

export default component.exports